import { useAppSelector } from "@app-redux/hooks";
import { AuthState } from "@src/redux/slices/authSlice";
import { ICurator } from "@src/types/curator";
import { IAuthUser, RoleType } from "@src/types/user";

export const useAuthUser = (): IAuthUser | null => {
  const { user } = useAppSelector((state) => state.auth);
  return user || null;
};

export const useRole = (): RoleType => {
  const role = useAppSelector((state) => state.auth.role);
  return role?.type || "curator";
};

export const useAuthCurator = (): ICurator => {
  const { curator } = useAppSelector((state) => state.auth);
  return (
    curator || {
      id: 0,
      documentId: "",
      name: "",
      countryCode: "",
      createdAt: "",
      updatedAt: "",
      publishedAt: "",
      visible: false,
      isSubcurator: false,
      articleEditor: false,
    }
  );
};

export const useAuthState = (): AuthState => {
  return useAppSelector((state) => state.auth);
};
